#@import Booking.Presenters.Base
#@export Booking.Presenters.Info

class Booking.Presenters.Info extends Booking.Presenters.Base

  toHash: ->
    selectedOption = @model.getSelectedOption()
    option = selectedOption or @model.getOptions().cheapest()

    optionSelected: selectedOption?
    price: option.getFormattedPrice()
